import { defineStaticListFilter } from '../engine/descriptor';
import { FilterId, FilterType } from '../types/filters';

export const REMOTE_SUITABILITY_SELECTIONS = [
  { value: '0', label: 'Very Low' },
  { value: '1', label: 'Low' },
  { value: '2', label: 'Medium' },
  { value: '3', label: 'High' },
  { value: '4', label: 'Very High' },
];

export const remoteSuitabilityDescriptor = defineStaticListFilter({
  definition: {
    id: FilterId.REMOTE_SUITABILITY,
    name: 'Remote Suitability',
    type: FilterType.STATIC_LIST,
    selections: [],
    isVisible: true,
  },
  multi: { id: FilterId.MULTI_REMOTE_SUITABILITY },
});
